"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ToastNotificationsListContainer = exports.ToastNotificationsList = void 0;
var react_1 = __importStar(require("react"));
var GenericNotification_1 = __importDefault(require("./components/GenericNotification"));
var ToastNotificationsList_module_scss_1 = __importDefault(require("./ToastNotificationsList.module.scss"));
var ToastNotificationsList = function (_a) {
    var notifications = _a.notifications, onHide = _a.onHide;
    return (react_1["default"].createElement("div", { className: ToastNotificationsList_module_scss_1["default"].list }, notifications.map(function (notification) { return (react_1["default"].createElement(GenericNotification_1["default"], { key: notification.id, style: "toast", type: notification.type, title: notification.title, autohide: notification.autohide, autohideDelay: notification.autohideDelay, automationId: notification.automationId, persistent: notification.persistent, onHide: function () {
            if (typeof notification.onHide !== "undefined") {
                notification.onHide();
            }
            onHide(notification.id);
        } }, notification.message)); })));
};
exports.ToastNotificationsList = ToastNotificationsList;
var ToastNotificationsListContainer = function (_a) {
    var removeToastNotification = _a.removeToastNotification, registerSetNotificationsCallback = _a.registerSetNotificationsCallback;
    var _b = (0, react_1.useState)([]), notifications = _b[0], setNotifications = _b[1];
    // Pass the local setNotifications function back up to the caller
    // via the registerSetNotificationsCallback
    (0, react_1.useEffect)(function () {
        registerSetNotificationsCallback(setNotifications);
    }, [setNotifications]);
    return (react_1["default"].createElement(exports.ToastNotificationsList, { notifications: notifications, onHide: removeToastNotification }));
};
exports.ToastNotificationsListContainer = ToastNotificationsListContainer;
//# sourceMappingURL=ToastNotificationsList.js.map